import React from 'react';


export interface IModalWindow {
    isOpen: boolean
    open: VoidFunction
    close: VoidFunction
}

export function useModalWindow() : IModalWindow {
    const [_isOpen, _setOpen] = React.useState(false);

    const open = React.useCallback(() => {
        _setOpen(true);
    }, []);

    const close = React.useCallback(() => {
        _setOpen(false);
    }, []);

    return {
        isOpen: _isOpen,
        open,
        close,
    }
}